import { ShortInstrumentResponse } from 'app/modules/instruments/responses';
import { U21TableColumn } from 'app/shared/u21-ui/components';

import { ROUTES_MAP } from 'app/shared/utils/routes';
import { IconArrowRight } from '@u21/tabler-icons';
import { BASE_BLOCKED_REASONS_OPTIONS } from 'app/modules/detectionModels/components/scenarioWidgets/consortium/constants';

type InstrumentTableColumn = Partial<
  U21TableColumn<ShortInstrumentResponse, any>
> & {
  id: string;
};

const ACTION_REASON_DISPLAY_NAME_MAPPING: Record<string, string> =
  BASE_BLOCKED_REASONS_OPTIONS.reduce(
    (acc, { value, text }) => ({ ...acc, [value]: text }),
    {},
  );

export const ACTION_REASON_COLUMN: InstrumentTableColumn = {
  id: 'action_reason',
  accessor: (instrument) =>
    instrument.action_reason
      ? ACTION_REASON_DISPLAY_NAME_MAPPING[instrument.action_reason]
      : undefined,
};

export const INSTRUMENT_COLUMN_CONFIG = {
  [ACTION_REASON_COLUMN.id]: ACTION_REASON_COLUMN,
};

export const GOTO_COLUMN: InstrumentTableColumn = {
  id: 'goto',
  type: 'button',
  cellProps: (instrument) => ({
    children: <IconArrowRight />,
    to: ROUTES_MAP.instrumentsId.path.replace(':id', String(instrument.id)),
  }),
  disableSortBy: true,
};
